import { render, staticRenderFns } from "./WikiCollectionReadOnly.vue?vue&type=template&id=3e7a33b8&"
import script from "./WikiCollectionReadOnly.vue?vue&type=script&lang=js&"
export * from "./WikiCollectionReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports